import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { initSentry } from './lib/sentry'
import { SentryErrorBoundaryWrapper } from './components/ErrorBoundary'

// Initialize Sentry (will only work if VITE_SENTRY_DSN is set)
initSentry()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <SentryErrorBoundaryWrapper>
      <App />
    </SentryErrorBoundaryWrapper>
  </React.StrictMode>
)
